import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Insights from '@/comp/pages/ValueDashboardPage/Insights/Insights';

const OpenInsightsReportPage = observer(() => {
  const { t } = useTranslation();

  const description = (
    <div>
      <p>{t('openInsightsReportDescriptionOne')}</p>
      <p>{t('openInsightsReportDescriptionTwo')}</p>
    </div>
  );

  return (
    <Container>
      <Insights
        title={t('Open Insights')}
        className="card-item"
        description={description}
        animation={false}
        tabKey={'events'}
        pendingTasksOnly={true}
        eventsLimit={10}
      />
      <div>{t('openInsightsReportFooterText')}</div>
    </Container>
  );
});

const Container = styled.div`
  .insights-card-wrapper {
    width: auto;
    margin: ${({ theme: { token } }) => token.marginMD}px auto ${({ theme: { token } }) => token.marginXXL}px;

    .insights-card {
      width: auto;
      height: auto;

      div#rc-tabs-0-panel-events {
        & > div {
          height: auto;
        }

        div.ant-table-wrapper {
          overflow-y: visible;
          height: auto;

          tr.highlighted-row {
            background: none;
          }
        }
      }

      label.ant-checkbox-wrapper {
        display: none !important;
      }
    }
  }

  .description {
    p {
      margin-bottom: ${({ theme: { token } }) => token.marginMD}px !important;
    }
  }
`;

export default OpenInsightsReportPage;
